export const ResourcesHomeSteps = [
  {
    disableBeacon: true,
    target: "[data-tour-target='resources-tab']",
    content:
      "This is your resources home page. Resources let you keep track of where things are on a map. They can be things or organizations, and you can group them.",
  },
  {
    disableBeacon: true,
    target: "[data-tour-target='resources-list']",
    content:
      "This is your resources list. Here you can see your resources in a list.",
  },
  {
    disableBeacon: true,
    target: "[data-tour-target='resources-map']",
    content:
      "This is your resources map. Here you can see your resources on a map.",
  },
];
